import cloneDeep from 'lodash/cloneDeep'
import Storage from '@/services/storageLib'
import status from '@/services/constants/status'
import {
  hasConversationInitiated,
  isTypeBOT,
  playNotificationSound,
  isDismissCalloutBubbleOnCrossEnabled,
  removeCalloutBubbleContainer,
  renderCalloutBubble
} from '@/services/utils'
import { constantStrings, surveyForm } from '@/services/constants'
import I18n from '@/services/localization/i18n-setup'
import { checkLiveAgentDeskName } from '@/services/liveAgent/utils/utils'
import calloutBubbleMessanger from '../services/calloutBubbleMessanger'
import findLast from 'lodash/findLast'
import VoiceState from '../services/voiceConstants'
import { updateIframeHeaderTitle } from '../services/utils'

export default {
  UPDATE_BROWSER_FONT_SIZE_SETTING(state, data) {
    state.browserFontSizeSetting = data
  },
  UPDATE_SUPPORT_ICON_STATE(state, data) {
    state.supportIconState = data
  },
  UPDATE_BLANK_SCREEN_STATE(state, data) {
    state.blankScreen = {
      ...state.blankScreen,
      ...data
    }
  },
  UPDATE_TERMS_AND_CONDITIONS_STATE(state, data) {
    state.termsAndConditions = data
  },
  UPDATE_HIGH_PRIORITY_ALERT_STATE(state, data) {
    state.alerts.highPriorityAlert = data
  },
  UPDATE_MEDIUM_PRIORITY_ALERT_STATE(state, data) {
    state.alerts.mediumPriorityAlert = data
  },
  UPDATE_GREETING_TRIGGER_ON_ALERT_CLOSURE_STATE(state, data) {
    state.alerts.triggerGreeting = data
  },
  UPDATE_GREETING_TRIGGER_ON_TERMS_CLOSURE_STATE(state, data) {
    state.termsAndConditions.triggerGreeting = data
  },
  UPDATE_QUICK_REPLY_ON_TERMS_CLOSURE_STATE(state, data) {
    state.termsAndConditions.quickReply = data
  },
  UPDATE_USER_DEVICE_DETAILS(state, data = {}) {
    state.deviceDetails = { ...data, ...state.deviceDetails }
  },
  UPDATE_FALLBACK_MECHANISM_STATE(state, data) {
    state.fallbackMechanismState = {
      ...state.fallbackMechanismState,
      ...data
    }
  },
  UPDATE_COOKIE_VALUES_COPY_STATE(state, data) {
    state.cookieValuesCopy = {
      ...state.cookieValuesCopy,
      ...data
    }
    state.cookieValuesCopy = Object.entries(state.cookieValuesCopy).reduce(
      (acc, [key, value]) => {
        if (value !== undefined || value !== null) {
          acc[key] = value
        }
        return acc
      },
      {}
    )
  },
  UPDATE_SURVEY_FORM_STATE(state, data) {
    state.surveyFormState = data
  },
  UPDATE_TRIGGER_MINIMIZE_VALID_STATE(state, data) {
    state.isTriggerMinimizeValid = data || false
  },
  UPDATE_UNREAD_MESSAGES_STATUS(state, data) {
    state.unreadMessagesState = data
    Storage.setLocalStorageData(constantStrings.UNREAD_MESSAGES_STATE, data)
  },
  UPDATE_MQTT_CONNECTION_STATUS(state, data) {
    state.isMqttConnected = data
  },
  UPDATE_CALLOUT_BUBBLE_LOADED(state, data) {
    state.isCalloutBubbleLoaded = data
  },
  UPDATE_WIDGET_STATUS(state, data) {
    state.widgetStatus = data
  },
  UPDATE_CURRENT_SCOPED_FORM_ID(state, data) {
    state.currentScopedFormID = data
  },
  UPDATE_CSAT_STATE(state, data) {
    state.csat = {
      ...state.csat,
      ...data
    }
  },
  UPDATE_SURVEY_RULES(state, { type, rule, timerId }) {
    switch (type) {
      case surveyForm.WIDGET_EVENT_IDLE_USER:
        if (rule) state.surveyRule.idleTimeoutRule.rule = rule
        if (timerId) state.surveyRule.idleTimeoutRule.timerId = timerId
        break
      case surveyForm.WIDGET_EVENT_CHAT_END:
        if (rule) state.surveyRule.endChatRule.rule = rule
        break
      case surveyForm.WIDGET_EVENT_SESSON_EXPIRE:
        if (rule) state.surveyRule.sessionTimeoutRule.rule = rule
        break
      default:
        break
    }
  },
  UPDATE_SCHEMA_FORM_LABELS(state, data) {
    state.schemaFormLabels = data
  },
  UPDATE_CLEAR_CONVERSATION_STATUS(state, data) {
    state.clearConversationState.clearConversation = data
  },
  UPDATE_CLEAR_CONVERSATION_STATUS_TO_PENDING(state, data) {
    state.clearConversationState.status = data
  },
  UPDATE_OVERLAY_STATUS(state, data) {
    state.isOverlayActive = data
  },
  UPDATE_END_CHAT_STATUS(state, data) {
    state.endChatCustomFieldStatus = data
  },
  UPDATE_INPUT_FIELD_DISABLE_STATUS(state, data) {
    state.inputFieldDisableStatus = data
  },
  UPDATE_INPUT_FIELD_TEMP_DISABLE_STATUS(state, data) {
    state.inputFieldTempDisableStatus = data
  },
  UPDATE_INPUT_FIELD_TEMP_DISABLE_STATUS_TIMER(state, data) {
    state.inputFieldTempDisableStatusTimer = data
  },
  UPDATE_INPUT_FIELD_ON_SEND_DISABLE_TIMER(state, data) {
    state.inputFieldOnSendDisableTimer = data
  },
  UPDATE_INPUT_FIELD_HIDDEN_STATUS(state, data) {
    state.inputFieldHiddenStatus = data
  },
  UPDATE_FORM_CONTROLS_BUTTON_STATE(state, data) {
    state.formControlsButtonState = data
  },
  UPDATE_PRIMARY_LANGUAGE(state, data) {
    state.primaryLanguage = data
  },
  UPDATE_CONNECTION_STATUS(state, data) {
    state.connectionStatus = data
  },
  FORM_CONTROLS_CLICKED_MESSAGE_ID(state) {
    let chats = state.chats,
      chatsLength = chats.length,
      chatsMessagesLength = chats[chatsLength - 1].messages.length
    state.formControlsClickedMessageId =
      chats[chatsLength - 1].messages[chatsMessagesLength - 1].messageId
  },
  SANITIZE_CHAT_HISTORY_FOR_FORMS(state) {
    let chats = state.chats,
      len = chats.length
    for (let index = 0; index < len; index++) {
      let possibleFormChatBlock = chats[index]
      let possibleFormChatBlockMessagesLength =
        possibleFormChatBlock?.messages?.length || 0
      if (
        isValidFormBlock(
          index,
          len,
          possibleFormChatBlock,
          possibleFormChatBlockMessagesLength,
          'EmbeddedForm'
        )
      ) {
        possibleFormChatBlock.messages[
          possibleFormChatBlockMessagesLength - 1
        ].messageValue.status[0] = status.SUBMITTED

        const isFormHidden =
          new URL(
            possibleFormChatBlock.messages[
              possibleFormChatBlockMessagesLength - 1
            ].messageValue.source
          ).searchParams.get(status.PERSISTENT.toLowerCase()) === 'true'
        possibleFormChatBlock.messages[
          possibleFormChatBlockMessagesLength - 1
        ].hide = !isFormHidden

        let nextpossibleFormChatBlockInHistory = chats[index + 1]
        let nextpossibleEFChatBlockAfterReloadMessagesLength =
          nextpossibleFormChatBlockInHistory.messages?.length || 0

        /* 
          If the nextpossibleFormChatBlockInHistory is not of type form then 
          it will be type of text (possibly the submission text of previous form question)

          If it is of type form, then it represents, user might have had pressed back, skip or reset button,
          and the entire nextpossibleFormChatBlockInHistory will be hidden.
        */

        currentAndNextSameFormType(
          nextpossibleFormChatBlockInHistory,
          possibleFormChatBlock,
          possibleFormChatBlockMessagesLength,
          nextpossibleEFChatBlockAfterReloadMessagesLength
        )

        const iframeHeightMessageBlock =
          nextpossibleFormChatBlockInHistory.messages.find(
            (message) => message?.messageValue?.iframeHeightWithOnlyQuestions
          )
        const iframeHeightWithOnlyQuestions =
          iframeHeightMessageBlock?.messageValue?.iframeHeightWithOnlyQuestions
        possibleFormChatBlock.messages[
          possibleFormChatBlockMessagesLength - 1
        ].messageValue.iframeHeightWithOnlyQuestions[0] =
          iframeHeightWithOnlyQuestions
      } else if (
        isValidFormBlock(
          index,
          len,
          possibleFormChatBlock,
          possibleFormChatBlockMessagesLength,
          'SchemaForm'
        )
      ) {
        const formsubmissionInfo = state.formsSubmittedInfo
        const formSkipInfo = state.formSkipInfo
        const requestId =
          possibleFormChatBlock.messages[
            possibleFormChatBlockMessagesLength - 1
          ].requestId
        if (requestId in formsubmissionInfo) {
          possibleFormChatBlock.messages[
            possibleFormChatBlockMessagesLength - 1
          ].messageValue.status[0] = status.SUBMITTED
          setResponseValue(
            possibleFormChatBlock,
            state.formsSubmittedInfo[requestId],
            possibleFormChatBlockMessagesLength
          )
        } else if (requestId in formSkipInfo) {
          possibleFormChatBlock.messages[
            possibleFormChatBlockMessagesLength - 1
          ].messageValue.status[0] = status.SUBMITTED
          possibleFormChatBlock.messages[
            possibleFormChatBlockMessagesLength - 1
          ].hide = true
        }
      } else if (
        isValidFormBlock(
          index,
          len,
          possibleFormChatBlock,
          possibleFormChatBlockMessagesLength,
          'LLMSchemaForm'
        )
      ) {
        const formsubmissionInfo = state.formsSubmittedInfo
        const formSkipInfo = state.formSkipInfo
        let formIndex = possibleFormChatBlockMessagesLength - 1
        for (
          let index = possibleFormChatBlockMessagesLength - 1;
          index >= 0;
          index--
        ) {
          if (possibleFormChatBlock.messages[index]?.type === 'LLMSchemaForm') {
            formIndex = index
            break
          }
        }
        const requestId = possibleFormChatBlock.messages[formIndex].requestId
        if (requestId in formsubmissionInfo) {
          possibleFormChatBlock.messages[formIndex].messageValue.status = [
            status.SUBMITTED
          ]
          setLLMFormResponseValue(
            possibleFormChatBlock,
            state.formsSubmittedInfo[requestId],
            possibleFormChatBlockMessagesLength,
            formIndex
          )
        } else if (requestId in formSkipInfo) {
          possibleFormChatBlock.messages[
            possibleFormChatBlockMessagesLength - 1
          ].messageValue.status = [status.SUBMITTED]
          possibleFormChatBlock.messages[
            possibleFormChatBlockMessagesLength - 1
          ].hide = true
        }
      } else if (
        isValidFormBlock(
          index,
          len,
          possibleFormChatBlock,
          possibleFormChatBlockMessagesLength,
          'SurveyForm'
        )
      ) {
        possibleFormChatBlock.messages[
          possibleFormChatBlockMessagesLength - 1
        ].messageValue.status[0] = status.SUBMITTED

        let nextpossibleFormChatBlockInHistory = chats[index + 1]
        let nextpossibleEFChatBlockAfterReloadMessagesLength =
          nextpossibleFormChatBlockInHistory?.messages?.length || 0

        currentAndNextSameFormType(
          nextpossibleFormChatBlockInHistory,
          possibleFormChatBlock,
          possibleFormChatBlockMessagesLength,
          nextpossibleEFChatBlockAfterReloadMessagesLength
        )
      } else if (
        possibleFormChatBlock.isAgent &&
        checkLiveAgentDeskName(constantStrings.ZENDESK) &&
        isChatBlockValid(
          possibleFormChatBlockMessagesLength,
          possibleFormChatBlock,
          'SurveyForm'
        )
      ) {
        possibleFormChatBlock.messages[
          possibleFormChatBlockMessagesLength - 1
        ].messageValue.status[0] = status.SUBMITTED
      }
    }
  },
  FORM_CONTROLS_CLICKED(state, data) {
    state.formControlsClicked = data
  },
  SHOW_FORM_CONTROLS(state, data) {
    state.showFormControls = data
  },
  UPDATE_CHAT_WIDGET_FULLSCREEN_STATUS(state, data) {
    if (
      state.widgetConfig?.brandGPT?.enable &&
      state.widgetConfig?.brandGPT?.isResizeOff &&
      !data
    )
      return
    state.isChatWidgetFullScreen = data
  },
  UPDATE_KNOWLEDGE_AI_SOURCES(state, data) {
    state.knowledgeAISourcesState = data
  },
  UPDATE_FILE_ATTACHMENT_ICON(state, data) {
    state.isFileAttachmentIconDisabled = data
  },
  UPDATE_ACTIONABLE_NBA_OPTIONS(state, data) {
    state.actionableNBAOptions = data
  },
  UPDATE_NON_ACTIONABLE_NBA_OPTIONS(state, data) {
    state.nonActionableNBAOptions = data
  },
  UPDATE_NON_ACTIONABLE_NBA_OVERLAY_ENABLED(state, data) {
    state.nonActionableNBAOverlayEnabled = data
  },
  UPDATE_BOT_REF_ID(state, data) {
    state.botRefId = data
  },
  UPDATE_WIDGET_ID(state, data) {
    state.widgetId = data
  },
  UPDATE_USER_ID(state, data) {
    state.user.id = data
  },
  UPDATE_EMAIL_ID(state, data) {
    state.user.email = data
  },
  UPDATE_WIDGET_CONFIG(state, data) {
    state.widgetConfig = data
    updateIframeHeaderTitle(state.widgetConfig?.supportIconConfig?.ariaLabel)
    setTimeout(() => {
      renderCalloutBubble()
    }, 0)
  },
  UPDATE_FEATURE_FLAGS_LIST(state, data) {
    state.featureFlagList = data
  },
  UPDATE_FORM_ENCRYPTION_PUBLIC_KEY(state, data) {
    state.formEncryptionPublicKey = data
  },
  UPDATE_BOT_PCI_POLICY(state, data) {
    state.botPCIPolicy = data
  },
  UPDATE_BOT_DETAILS(state, data) {
    for (let config in state.botDetails) {
      if (data?.config) {
        state.botDetails[config] = data[config]
      }
    }
  },
  UPDATE_USER_MESSAGE(state, data) {
    state.userMessage = data
  },
  UPDATE_CONTROL_TYPE(state, data) {
    state.controlType = data
    Storage.setLocalStorageData('controlType', data)
  },
  UPDATE_AGENT_INFO(state, data) {
    state.agentInfo = data
  },
  UPDATE_HANDOFF_DEPARTMENT(state, data) {
    state.customHandoffDepartment = data
  },
  UPDATE_VISITOR_INFO(state, data) {
    state.visitorInfo = { ...state.visitorInfo, ...data }
  },
  CLEAR_VISITOR_INFO(state) {
    state.visitorInfo = {}
  },
  TOGGLE_CHAT_WINDOW_STATUS(state, { data, getters }) {
    if (
      state.widgetConfig?.brandGPT?.enable &&
      state.widgetConfig?.brandGPT?.isResizeOff &&
      !data
    )
      return
    state.isWindowMaximized = data
    state.widgetStatus.status = data ? status.OPEN : status.CLOSE
    if (getters.isKnowledgeAiEnabled && data) {
      state.widgetStatus.isFullScreen = true
    }
  },
  SORT_CHATS_ACC_TO_TIMESTAMP(state) {
    state.chats = state.chats.sort(
      (chat1, chat2) => chat1.timestamp - chat2.timestamp
    )
  },
  UPDATE_CHATS(state, data) {
    const isValidMessageToPlayNotification =
      !Array.isArray(data) &&
      data.initiator !== constantStrings.WEBHOOK_HISTORY &&
      !data.hide &&
      (data.isMessageSeparator || data.userMessage || data.messages?.length > 0)
    if (isValidMessageToPlayNotification) {
      playNotificationSound(state, data)
    }
    // delete additional metadata which added during commiting UPDATE_CHATS
    delete data.initiator
    state.chats.push(data)
  },
  UPDATE_CHAT_AT_ITH_POS(state, data) {
    const chats = state.chats
    const { position, chatBlock } = data
    state.chats = [
      ...chats.slice(0, position),
      chatBlock,
      ...chats.slice(position + 1)
    ]
  },
  INSERT_CHAT_AT_ITH_POS(state, data) {
    const chats = state.chats
    const { position, chatBlock } = data
    state.chats = [
      ...chats.slice(0, position),
      chatBlock,
      ...chats.slice(position)
    ]
  },
  INSERT_MULTIPLE_CHATS_AT_TOP(state) {
    state.chats = [...state.previousChats, ...state.chats]
    state.previousChats = []
  },
  UPDATE_PREVIOUS_CHAT(state, { chatBlock }) {
    state.previousChats.unshift(chatBlock)
  },
  DELETE_CHAT_AT_ITH_POS(state, position) {
    const chats = [...state.chats]
    chats.splice(position, 1)
    state.chats = [...chats]
  },
  CLEAR_CHATS(state) {
    state.chats = []
  },
  UPDATE_DISPLAY_NAME_FOR_AGENTDESK(state, data) {
    state.visitorDisplayNameForAgentDesk = data
  },
  UPDATE_MESSAGE_TAGS(state, data) {
    state.messageTags = data ? [...state.messageTags, ...data] : []
  },
  UPDATE_PROGRESSIVE_TYPING_INDICATOR_CONFIG(state, data) {
    if (data) {
      state.progressiveTypingIndicatorConfig = data
    } else {
      state.progressiveTypingIndicatorConfig = state.widgetConfig
        .progressiveTypingIndicator?.config || [
        {
          duration: 2000,
          text: ''
        },
        {
          duration: 3000,
          text: 'Looking into that now...'
        },
        {
          duration: 5000,
          text: 'Gathering relevant information...'
        },
        {
          duration: 20000,
          text: 'Almost there, just wrapping it up'
        }
      ]
    }
  },
  UPDATE_LAST_CHAT_MESSAGE(state, data) {
    const lastChat = state.chats.slice(-1)[0]
    /* 
      Check if the last message is from the user is yes the push to the chats array else push to messages array.
     */
    const lastMessageisUser = lastChat?.messages?.slice(-1)[0]
    if (lastMessageisUser?.isUser) {
      state.chats.push(data)
    } else {
      lastChat?.messages?.push(data)
    }
    const isValidMessageToPlayNotification = !data.hide
    if (isValidMessageToPlayNotification) {
      playNotificationSound(state, data)
    }
  },
  UPDATE_FIRST_CHAT_MESSAGE(state, data) {
    const firstChat = state.previousChats.slice[0]
    /* 
     for loading history reversely 
     Check if the first message is from the user is yes the push to the chats array else push to messages array.
    */
    const firstMessage = firstChat?.messages?.slice(-1)[0]
    if (firstMessage?.isUser) {
      state.previousChats = [
        ...state.previousChats.slice(0, 1),
        data,
        ...state.previousChats.slice(1)
      ]
    } else {
      firstChat?.messages?.push(data)
    }
    const isValidMessageToPlayNotification = !data.hide
    if (isValidMessageToPlayNotification) {
      playNotificationSound(state, data)
    }
  },
  UPDATE_LAST_CHUNK_MESSAGE(state, data) {
    const chats = state.chats
    const lastChat = chats.slice(-1)[0]
    const attachment = lastChat?.messages?.find((message) => {
      if (
        message?.messageValue?.attachmentResponseType ===
          'ANSWER_AI_RESPONSE' &&
        message?.messageValue?.timestamp === data?.attachment?.timestamp
      ) {
        return true
      }
      return false
    })
    if (attachment) {
      if (attachment.messageValue.text) {
        attachment.messageValue.text += data?.attachment?.text
        attachment.messageValue.isReviewEnabled =
          data?.attachment?.isReviewEnabled ||
          attachment?.messageValue?.isReviewEnabled
        if (data.attachment && 'isStreaming' in data.attachment) {
          attachment.messageValue.isStreaming = Boolean(
            data?.attachment?.isStreaming
          )
          attachment.messageValue.isPartialStreaming = Boolean(
            data?.attachment?.isPartialStreaming
          )
        }
      } else {
        attachment.messageValue.text = data?.attachment?.text
      }
      state.chats[state.chats.length - 1] = { ...lastChat }
      state.chats = chats
    }
  },
  UPDATE_LAST_CHUNK_MESSAGE_V2(state, data) {
    const chats = state.chats
    const lastChat = chats.slice(-1)[0]
    const attachment = findLast(lastChat?.messages, (message) => {
      if (
        message?.messageValue?.attachmentResponseType === 'ANSWER_AI_RESPONSE'
      ) {
        return true
      }
      return false
    })
    if (attachment) {
      if (attachment.messageValue.text) {
        attachment.messageValue.text += data?.attachment?.text
        attachment.messageValue.isReviewEnabled =
          data?.attachment?.isReviewEnabled ||
          attachment?.messageValue?.isReviewEnabled
        attachment.messageValue.quickReply = data?.messageValue?.quickReply
        if (data.attachment && 'isStreaming' in data.attachment) {
          attachment.messageValue.isStreaming = Boolean(
            data?.attachment?.isStreaming
          )
          attachment.messageValue.isPartialStreaming = Boolean(
            data?.attachment?.isPartialStreaming
          )
        }
      } else {
        attachment.messageValue.text = data?.attachment?.text
        attachment.messageValue.quickReply = data?.messageValue?.quickReply
        if (data?.attachment?.text) {
          attachment.hide = false
        }
      }
      state.chats[state.chats.length - 1] = { ...lastChat }
      state.chats = chats
    }
  },
  UPDATE_TEXT_CHUNK_MESSAGE(state, data) {
    const chats = state.chats
    const lastChat = chats.slice(-1)[0]
    const attachments = lastChat?.messages?.filter((message) => {
      if (
        message?.messageValue?.attachmentResponseType === 'ANSWER_AI_RESPONSE'
      ) {
        return true
      }
      return false
    })
    attachments.forEach((attachment) => {
      if (
        attachment &&
        attachment.messageValue.text &&
        data.attachment &&
        'isStreaming' in data.attachment
      ) {
        attachment.messageValue.isStreaming = Boolean(
          data?.attachment?.isStreaming
        )
        attachment.messageValue.isPartialStreaming = Boolean(
          data?.attachment?.isPartialStreaming
        )
      }
    })
    state.chats[state.chats.length - 1] = { ...lastChat }
    state.chats = chats
  },
  UPDATE_LAST_CHUNK_CAROUSEL_MESSAGE(state, data) {
    const chats = state.chats
    const lastChat = chats.slice(-1)[0]
    const attachment = findLast(lastChat?.messages, (message) => {
      if (
        message?.messageValue?.attachmentResponseType === 'ANSWER_AI_RESPONSE'
      ) {
        return true
      }
      return false
    })
    if (
      attachment &&
      attachment.type === 'CarouselResponse' &&
      attachment?.messageValue?.elements
    ) {
      attachment.messageValue.elements.push(...data.messageValue.elements)
      if (data.messageValue.isReviewEnabled) {
        attachment.messageValue.isReviewEnabled = true
      }
      if (data.messageValue.quickReply?.options?.length) {
        attachment.messageValue.quickReply = data.messageValue.quickReply
      }
      state.chats[state.chats.length - 1] = { ...lastChat }
      state.chats = chats
    }
  },
  ADD_FEEDBACK_FOR_LAST_ATTACHMENT(state) {
    const chats = state.chats
    const lastChat = chats.slice(-1)[0]
    const attachment = findLast(lastChat?.messages, (message) => {
      if (
        message?.messageValue?.attachmentResponseType ===
          'ANSWER_AI_RESPONSE' &&
        !message.hide
      ) {
        return true
      }
      return false
    })
    if (attachment) {
      attachment.messageValue.isReviewEnabled = true
    }
  },
  UPDATE_IDLE_TIMEOUT_ID(state, data) {
    state.showEndChatFlow.timerId = data
  },
  UPDATE_AGENT_DESK_IDLE_TIMEOUT_ID(state, data) {
    state.agentDesk.idleTimeoutTimerId = data
  },
  UPDATE_OVERLAY_IDLE_TIMEOUT_ID(state, data) {
    state.overlayTimerId = data
  },
  REPLACE_LAST_IMAGE_SKELETON(state, data) {
    const lastFileUploadHolderIndex = state.chats.reduceRight(
      (prev, cur, index) => (prev === -1 && cur.isAppStateOnly ? index : prev),
      -1
    )
    lastFileUploadHolderIndex !== -1 &&
      state.chats.splice(lastFileUploadHolderIndex, 1, data)
  },
  UPDATE_QUICK_REPLY_OPTIONS(state, data) {
    state.quickReplyOptions = data
  },
  UPDATE_INDICATOR_STATUS(state, data) {
    state.showTypingIndicator = data
  },
  UPDATE_FORM_STATUS(state, data) {
    const updatedChats = cloneDeep(state.chats)
    const len = updatedChats.length
    // Form response should lie in last 2 message blocks, but to be on the safe side we are using 5
    for (let index = len - 1; len - index <= 5; index--) {
      const chats = updatedChats[index]
      let isFormUpdated = false
      if (!chats) return
      chats.messages = chats?.messages?.map((message) => {
        if (
          message.type === 'HumanHandoffForm' &&
          (message.messageValue?.values?.['status'][0] === status.PENDING ||
            (message.type === data.type && data.updateAcrossTabs))
        ) {
          message.messageValue.values['status'][0] = data.values['status'][0] // REJECTED/SUBMITTED
          message.hide = data.values['status'][0] === status.REJECTED // Hide If Rejected
          isFormUpdated = true
        } else if (
          message.type === 'EmbeddedForm' &&
          (message.messageId === data.messageId ||
            (message.type === data.type && data.updateAcrossTabs))
        ) {
          message.messageValue.status[0] = status.SUBMITTED
          if (data.iframeHeightWithOnlyQuestions) {
            message.messageValue.iframeHeightWithOnlyQuestions =
              data.iframeHeightWithOnlyQuestions
          }
          if (data.hideFormUponControlsAction) {
            //Hiding the form and its question too
            message.hide = true
            chats.messages.map((message) => (message.hide = true))
          }
          if (data.iframeHidden) {
            message.hide = true
          }
          isFormUpdated = true
        } else if (
          message.type === 'SchemaForm' &&
          (message.messageId === data.messageId ||
            (message.type === data.type && data.updateAcrossTabs))
        ) {
          message.messageValue.status[0] = status.SUBMITTED
          if (data.hideFormUponControlsAction) {
            //Hiding the form and its question too
            message.hide = true
            chats.messages.map((message) => (message.hide = true))
          }
          isFormUpdated = true
        } else if (
          message.type === 'SurveyForm' &&
          (message.messageId === data.messageId ||
            (message.type === data.type && data.updateAcrossTabs))
        ) {
          message.hide = data?.hide
          message.messageValue.status[0] = data.messageValue.status[0]
          if (data.messageValue?.submitSurveyInfo) {
            const schema = JSON.parse(data.messageValue?.schema)
            schema.submitSurveyInfo = data.messageValue.submitSurveyInfo
            message.messageValue.schema = JSON.stringify(schema)
          }
          isFormUpdated = true
        } else if (
          message.type === 'LLMSchemaForm' &&
          (message.messageId === data.messageId ||
            (message.type === data.type && data.updateAcrossTabs))
        ) {
          const values = data?.labels?.split('\n') || []
          const schemaArray = message.messageValue.schema
          const length = schemaArray.length
          for (let ind = 0; ind < length; ind++) {
            schemaArray[ind].responseValue = values[ind]
          }
          message.messageValue.status[0] = status.SUBMITTED

          isFormUpdated = true
        }
        return message
      })
      if (isFormUpdated) {
        updatedChats[index] = chats
        break
      }
    }
    state.chats = updatedChats
  },
  UPDATE_HISTORY_LOADING_STATUS(state, data) {
    state.isHistoryLoading = data
  },
  UPDATE_END_CHAT_MODAL_STATUS(state, data) {
    state.showEndChatFlow.enableWidget = data
  },
  UPDATE_END_CHAT_MODAL_ON_CHAT_RESTART(state, data) {
    state.showEndChatFlow.isChatRestart = data
  },
  UPDATE_CALLOUT_BUBBLE_CONFIG_PUBSUB(state, data) {
    state.calloutBubblePubsubConfig = data
  },
  UPDATE_CALLOUT_BUBBLE(state, data) {
    const calloutBubbleFromPubsub = Storage.getLocalStorageData(
      'showCalloutBubblePubsub'
    )
    if (calloutBubbleFromPubsub?.enabled && calloutBubbleFromPubsub?.data) {
      state.widgetConfig.calloutBubble = calloutBubbleFromPubsub?.data
    } else {
      state.widgetConfig.calloutBubble = data
    }
    // re-load the translation file for english language
    I18n.loadBotJsonConfigLocaleMessages()
  },
  UPDATE_CALLOUT_BUBBLE_ENABLED_FLAG(state, data = true) {
    // Conditions for enabling callout bubble
    const widthRange =
      !state.widgetConfig?.calloutBubble?.config?.exposedFnWidthRange &&
      Storage.getLocalStorageData('showCalloutBubblePubsub')?.enabled
    const showCalloutBubble =
      data &&
      fixedCalloutBubbleFlagsCheck(state, state.widgetConfig?.calloutBubble) &&
      widthRange
    state.isCalloutBubbleEnabled = showCalloutBubble
    if (state.widgetConfig?.calloutBubble?.calloutBubbleEnabled) {
      calloutBubbleMessanger.sendMessage({
        eventType: 'TOGGLE_CALLOUT_BUBBLE',
        data: { show: showCalloutBubble }
      })
      if (!showCalloutBubble) {
        removeCalloutBubbleContainer()
      }
    }
  },
  UPDATE_CALLOUT_BUBBLE_FLAG_FROM_PUBSUB(
    state,
    calloutBubble = { enabled: true }
  ) {
    const showCalloutBubble =
      calloutBubble?.enabled &&
      fixedCalloutBubbleFlagsCheck(state, calloutBubble?.data)
    state.isCalloutBubbleEnabled = showCalloutBubble
    // If CB is shown using pubsub from client, then after refresh it should show automatically
    // Hence storing a local storage variable
    Storage.setLocalStorageData('showCalloutBubblePubsub', calloutBubble)
    calloutBubbleMessanger.sendMessage({
      eventType: 'TOGGLE_CALLOUT_BUBBLE',
      data: { show: showCalloutBubble }
    })
    if (!showCalloutBubble) {
      removeCalloutBubbleContainer()
    }
  },
  UPDATE_USER_MESSAGE_SYNC(state) {
    const isUserMessageSyncKeyPresent =
      state.widgetConfig?.userMessageSyncAcrossTabs
    if (isUserMessageSyncKeyPresent) {
      state.userMessageSyncAcrossTabs = isUserMessageSyncKeyPresent
    }
  },
  UPDATE_TOKEN_IN_WIDGET(state, data) {
    state.authToken = data
  },
  UPDATE_WIDGET_VISITOR_INFO(state, widgetVisitorInfo) {
    state.widgetVisitorInfo = widgetVisitorInfo
  },
  UPDATE_USER_IP_ADDRESS(state, userIPAddress) {
    state.userIPAddress = userIPAddress
  },
  UPDATE_DEFAULT_ATTRIBUTES(state, defaultAttributes) {
    state.defaultAttributes = defaultAttributes
  },
  UPDATE_AUTHENTICATED_CONVERSATION_ID(state, data) {
    state.authenticatedConversationId = data
  },
  UPDATE_EXTERNAL_ID(state, data) {
    state.externalId = data
  },
  UPDATE_NOTIFICATION_SOUND(state, value) {
    state.notificationSound = value
  },
  UPDATE_AGENT_DESK_CONNECTION_STATUS(state, data) {
    state.agentDeskConnectionStatus = data
  },
  UPDATE_PRE_LOADER_ENABLED_STATUS(state, data) {
    state.preLoaderEnabled = data
  },
  UPDATE_PREVIOUS_CONVERSATION_LOADER(state, data) {
    state.previousCoversationLoader = data
  },
  UPDATE_QUICK_MENU_STATE(state, data) {
    state.quickMenuState = data
  },
  UPDATE_QUICK_MENU_VISIBILITY(state, data) {
    const oldQuickMenuState = state.quickMenuState
    state.quickMenuState = { ...oldQuickMenuState, visible: data }
  },
  UPDATE_QUICK_MENU_HANDLER(state, data) {
    state.quickMenuClickHandler = data
  },
  UPDATE_CURRENT_LOCALE(state, data) {
    state.currentLocale = data
  },
  UPDATE_FOCUS_ENABLE(state, data) {
    state.focusEnable = data
  },
  UPDATE_FOCUS_NODE(state, data) {
    state.focusNode = data
  },
  TOGGLE_SHOW_HEADER_DRAWER(state) {
    state.headerDrawerState.show = !state.headerDrawerState.show
  },
  UPDATE_INPUT_FIELD_STREAMING_DISABLE_STATUS(state, data) {
    state.inputFieldStreamingDisableStatus = data
  },
  UPDATE_INPUT_FIELD_ON_SEND_DISABLE_STATUS(state, data) {
    state.footer.disableInputOnSend.state = data
  },
  SHOW_EXTERNAL_HEADER_TEXT(state, data) {
    state.showExternalHeaderText = data
  },
  SHOW_HEADER_MENU_BUTTONS(state, data) {
    state.showHeaderMenuButtons = data
  },
  UPDATE_PROMPT_TEST_DETAILS(state, data) {
    state.promptTestDetails = data
  },

  UPDATE_VOICE_MODE(state, data) {
    state.isVoiceModeActive = data
    state.currentVoiceState = VoiceState.NONE
  },
  UPDATE_VOICE_STATE(state, data) {
    state.currentVoiceState = data
  },

  UPDATE_CSAT_SURVEY_TIME(state, data) {
    state.csatSurveyStartTime = data
  },
  SHOW_VISITOR_INFO_BUTTON(state, data) {
    state.showVisitorInfoButton = data
  },
  SHOW_VISITOR_INFO_FORM(state, data) {
    state.visitorInfoForm.isOpen = data
  },
  UPDATE_VISITOR_INFO_FORM(state, data) {
    state.visitorInfoForm.visitorInfoDetails = data
  },
  UPDATE_MASKED_VALUE_MAP(state, { text, maskedText, label, maskedLabel }) {
    state.maskedValueMap[maskedText] = text
    state.maskedValueMap[maskedLabel] = label
  },
  SET_CLIENT_CONFIG(state, data) {
    state.clientConfig = data
  }
}

const isValidFormBlock = (
  index,
  len,
  possibleFormChatBlock,
  possibleFormChatBlockMessagesLength,
  formType
) => {
  if (
    formType === 'SurveyForm' &&
    possibleFormChatBlock?.messages?.[possibleFormChatBlockMessagesLength - 1]
      ?.type === 'SurveyForm'
  ) {
    let schema =
      possibleFormChatBlock?.messages?.[possibleFormChatBlockMessagesLength - 1]
        ?.messageValue?.schema
    if (schema) {
      schema = JSON.parse(schema)
      return 'submitSurveyInfo' in schema || 'isSurveySkipped' in schema
    }
    return false
  }
  if (formType === 'LLMSchemaForm') {
    for (
      let index = possibleFormChatBlockMessagesLength - 1;
      index >= 0;
      index--
    ) {
      if (possibleFormChatBlock?.messages[index]?.type === 'LLMSchemaForm') {
        return true
      }
    }
    return false
  }
  return (
    index < len - 1 &&
    possibleFormChatBlockMessagesLength >= 2 &&
    possibleFormChatBlock?.messages[possibleFormChatBlockMessagesLength - 1]
      .type === formType
  )
}

const setResponseValue = (currentBlock, values, currentBlockLength) => {
  const specialChars = constantStrings.FORM_FIELDS_SPECIAL_CHARS
  const attributeSectionArray = values.split(specialChars[0])
  let responseValues = []
  if (
    attributeSectionArray[0] +
      specialChars[0] +
      attributeSectionArray[1] +
      specialChars[0] ===
    constantStrings.EVENT_LEARN_ATTRIBUTE
  ) {
    const regex = /(::value=)([^&]*)/g
    // Extracting values using match and mapping to format them
    const values = attributeSectionArray[2]
      .match(regex)
      .map((value) =>
        decodeURIComponent(value.replace('::value=', '').replace(/\+/g, ' '))
      )
    responseValues = values
  }

  const schema =
    currentBlock.messages[currentBlockLength - 1].messageValue.schema
  let jsonData = JSON.parse(schema)
  let schemaArray = jsonData[0].schema

  const length = schemaArray.length
  for (let ind = 0; ind < length; ind++) {
    schemaArray[ind].responseValue = responseValues[ind]
  }
  jsonData[0].schema = schemaArray
  const updatedSchema = JSON.stringify(jsonData)
  currentBlock.messages[currentBlockLength - 1].messageValue.schema =
    updatedSchema
}

const setLLMFormResponseValue = (currentBlock, values, _, formIndex) => {
  const responseValues = values?.split('\n') || []
  const schemaArray = currentBlock.messages[formIndex].messageValue.schema
  const length = schemaArray.length
  for (let ind = 0; ind < length; ind++) {
    schemaArray[ind].responseValue = responseValues[ind]
  }
  currentBlock.messages[formIndex].messageValue.schema = schemaArray
}

const isChatBlockValid = (
  possibleFormChatBlockMessagesLength,
  possibleFormChatBlock,
  formType
) => {
  return (
    possibleFormChatBlockMessagesLength > 0 &&
    possibleFormChatBlock?.messages[possibleFormChatBlockMessagesLength - 1]
      .type === formType
  )
}

const currentAndNextSameFormType = (
  nextpossibleFormChatBlockInHistory,
  possibleFormChatBlock,
  possibleFormChatBlockMessagesLength,
  nextpossibleEFChatBlockAfterReloadMessagesLength
) => {
  if (
    nextpossibleFormChatBlockInHistory?.messages?.length >= 2 &&
    possibleFormChatBlock.messages[possibleFormChatBlockMessagesLength - 1]
      .type ===
      nextpossibleFormChatBlockInHistory.messages[
        nextpossibleEFChatBlockAfterReloadMessagesLength - 1
      ].type
  ) {
    possibleFormChatBlock.messages.map((message) => (message.hide = true))
  }
}

const fixedCalloutBubbleFlagsCheck = (state, calloutBubble) => {
  const defaultFullScreenFlag = state?.isChatWidgetFullScreen
  const windomMaxFlag = state?.isWindowMaximized
  const interactionStartedFlag = hasConversationInitiated()
  const controlTypeAgentFlag = !isTypeBOT()
  const callOutBubbleflag =
    calloutBubble?.calloutBubbleEnabled &&
    !defaultFullScreenFlag &&
    !windomMaxFlag &&
    !interactionStartedFlag &&
    !controlTypeAgentFlag &&
    state.isMqttConnected &&
    !isDismissCalloutBubbleOnCrossEnabled()
  return callOutBubbleflag
}
